<template>
  <div >
    <v-card flat class="px-2" v-if="value && value.length > 0">
      <v-card-subtitle v-if="showTitle" class="text-decoration-underline pa-0">
        {{ $t("portfolio.Feedback.plural") }}
      </v-card-subtitle>
      <v-card-text>
        <v-card
          class="pa-3 ma-2"
          flat
          v-for="(feedback, index) in value"
          :color="$vuetify.theme.dark ? '#2d2d2d' : '#f9fafb'"
        >
          <v-row>
            <profileImage
              :size="32"
              :displayName="feedback.teacher.teacherName"
              :thumbnail="true"
              classCss="mt-3"
            />
            <v-spacer></v-spacer>

            <v-chip
              class="ma-2"
              small
              outlined
              label
              :title="feedback.createdDate | moment('YYYY/MM/DD - h:mm A')"
            >
              {{ dateFromNow(feedback.createdDate) }}
              <v-icon
                v-if="feedback.modifiedDate"
                small
                class="ms-1"
                :title="
                  `${$t('portfolio.general.modifiedDate')}: ${$options.filters.moment(
                    feedback.modifiedDate,
                    'YYYY/MM/DD - h:mm A'
                  )}`
                "
                >mdi-pencil</v-icon
              >
            </v-chip>
          </v-row>

          <v-card-text class="pa-3" dir="auto">
            <div>{{ feedback.feedbackText }}</div>
          </v-card-text>
          <v-card-actions class="d-flex justify-space-between">
            <div>
              <v-btn
                text
                small
                color="primary"
                @click="
                  activeFeedbackGuid = feedback.feedbackGuid;
                  $refs.commentsDialog.showDialog(4, feedback.feedbackGuid);
                "
              >
                <v-icon left>mdi-comment</v-icon>
                {{ $t("portfolio.comment.add") }}
              </v-btn>
              <v-btn
                text
                small
                color="primary"
                v-if="feedback.teacher.teacherGuid === $store.state.userData.guid"
                @click="$refs.feedbackDialog.showEditDialog(feedback)"
              >
                <v-icon left>mdi-pencil</v-icon>
                {{ $t("edit") }}
              </v-btn>
              <v-btn
                text
                small
                color="red"
                v-if="feedback.teacher.teacherGuid === $store.state.userData.guid"
                @click="
                  activeFeedback = feedback;
                  $refs.confirmActionDialog.showDialog();
                "
              >
                <v-icon left>mdi-delete</v-icon>
                {{ $t("delete") }}
              </v-btn>
            </div>
          </v-card-actions>

          <v-btn
            v-if="feedback.comments && feedback.comments.length > 0"
            class="ma-2"
            small
            depressed
            @click="
              feedback.showComments = !feedback.showComments;

              $forceUpdate();
            "
          >
            <v-icon color="primary" left>mdi-message</v-icon>
            {{ $t("portfolio.comment.plural") }} ({{ feedback.comments.length }})
            <v-icon> {{ feedback.showComments ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
          </v-btn>

          <v-expand-transition>
            <Comments
              v-if="feedback.showComments"
              :key="'comments_' + feedback.feedbackGuid"
              class="mx-4 mb-2"
              sourceType="4"
              :sourceGuid="feedback.feedbackGuid"
              v-model="feedback.comments"
              @input="$forceUpdate()"
          /></v-expand-transition>
        </v-card>
      </v-card-text>

      <FeedbackDialog ref="feedbackDialog" :sourceType="sourceType" @edit="editFeedbackHandler" />
      <ConfirmActionDialog
        ref="confirmActionDialog"
        :title="$t('portfolio.Feedback.delete')"
        :description="$t('portfolio.Feedback.deleteConfirm')"
        @confirm="handleConfirmDeleteAction"
      />
      <CommentsDialog ref="commentsDialog" @add="addCommentHandler" />
    </v-card>
    <NoData v-else-if="showNoData && !loading" />
  </div>
</template>

<script>
import ConfirmActionDialog from "../../confirmActionDialog.vue";
import Comments from "../comments/comments.vue";
import CommentsDialog from "../comments/commentsDialog.vue";
import FeedbackDialog from "./feedbackDialog.vue";
import NoData from "../../noData.vue";
import LoadingData from "../../loadingData.vue";
import profileImage from "../profileImage.vue";

export default {
  name: "Feedbacks",
  components: {
    Comments,
    ConfirmActionDialog,
    CommentsDialog,
    NoData,
    FeedbackDialog,
    LoadingData,
    profileImage
  },
  props: {
    showNoData: {
      type: Boolean,
      default: false
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    sourceGuid: {
      type: String || Number,
      required: true
    },
    sourceType: {
      type: String || Number,
      required: true
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  async created() {},
  data() {
    return {
      activeFeedbackGuid: null,
      loading: false
    };
  },
  methods: {
    addCommentHandler(x) {
        var commentList = this.value.find(ref => ref.feedbackGuid === this.activeFeedbackGuid);
        if (commentList) {
          if (!commentList.comments) {
            commentList.comments = [];
          }
          const index = commentList.comments.findIndex(c => c.commentGuid === x.commentGuid);
          if (index !== -1) {
            commentList.comments[index].commentText = x.commentText;
          } else {
            commentList.comments.unshift(x);
          }
          this.$forceUpdate();
      }
    },
    handleConfirmDeleteAction() {
      this.axios
        .post(`Feedback/Delete`, { feedbackGuid: this.activeFeedback.feedbackGuid })
        .then(() => {
          this.$emit(
            "input",
            this.value.filter(f => f.feedbackGuid !== this.activeFeedback.feedbackGuid)
          );
        })
        .catch(error => {
          console.error(error);
        });
    },

    addFeedback(feedback) {
      this.value.unshift(feedback);
    },
    editFeedbackHandler(feedback) {
      feedback.modifiedDate = this.$moment(new Date());
      const index = this.value.findIndex(f => f.feedbackGuid === feedback.feedbackGuid);

      if (index !== -1) {
        Object.assign(this.value[index], feedback);
      }
    }
  }
};
</script>

<style scoped>
.mt-4 {
  margin-top: 16px;
}
</style>
